export const enum MyClaimsTabs {
  AllClaims = 'AllClaims',
  MyClaims = 'MyClaims',
  AllClaimSets = 'AllClaimSets',
  MyClaimSets = 'MyClaimSets',
}
